import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { dispatchFullLoading } from "@hooks/useFullLoading";
import fetcher from "@/common/axiosInstance";
export var api__getReferralData = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(orderId) {
    var _res$data, _res$data3;
    var formData, res, _res$data2;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          dispatchFullLoading(true);
          formData = new FormData();
          formData.append("id", orderId);
          _context.n = 1;
          return fetcher().post("/order/referral", formData);
        case 1:
          res = _context.v;
          console.log(res, 'referral data');
          if (!((res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code) === 200)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.data);
        case 2:
          throw new Error(res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.message);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return function api__getReferralData(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var api__getReferralList = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(orderId, listType, page) {
    var formData, payload;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          formData = new FormData();
          formData.append("id", orderId);
          formData.append("type", listType);
          _context2.n = 1;
          return fetcher().post("/order/referral-list?page=".concat(page), formData);
        case 1:
          payload = _context2.v;
          return _context2.a(2, {
            list: payload.data.data.items,
            currentPage: payload.data.data.current_page,
            pageCount: payload.data.data.page_count
          });
      }
    }, _callee2);
  }));
  return function api__getReferralList(_x2, _x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();